import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f525be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-sheet" }
const _hoisted_2 = { class: "mt-4 bg-white rounded" }
const _hoisted_3 = { class: "p-5 flex items-center justify-end" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col items-center justify-center mt-3 pb-6"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка списка...", -1))
const _hoisted_6 = {
  key: 2,
  class: "max-w-full overflow-hidden overflow-x-auto",
  style: {"padding-bottom":"70px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_RouteSheetFilters = _resolveComponent("RouteSheetFilters")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_route_sheet_row = _resolveComponent("route-sheet-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Выдача курьеру" }),
    _createVNode(_component_RouteSheetFilters, {
      class: "mt-9",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_new_limit, {
          disabled: 
                        _ctx.state.is_loading ||
                        _ctx.state.is_failed ||
                        !_ctx.new_dispatcher_store.dispatcherSectorIds.length
                    ,
          value: _ctx.state.filters.limit,
          "total-items": _ctx.state.filters.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading || _ctx.state.is_failed,
          "current-page": _ctx.state.filters.current_page,
          "total-pages": _ctx.state.filters.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ]),
      _createElementVNode("div", null, [
        (_ctx.state.is_loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_loader, { class: "primary" }),
              _hoisted_5
            ]))
          : (_ctx.state.is_failed)
            ? (_openBlock(), _createBlock(_component_failed_fetch, {
                key: 1,
                loading: _ctx.state.is_loading,
                text: "При получении списка маршрутных листов произошла ошибка",
                onRefresh: _ctx.loadData
              }, null, 8, ["loading", "onRefresh"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_new_table, {
                  columns: _ctx.TABLE_COLUMNS,
                  rows: _ctx.state.list
                }, {
                  td: _withCtx(({ column, row }) => [
                    _createVNode(_component_route_sheet_row, {
                      column: column,
                      row: row
                    }, null, 8, ["column", "row"])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ]))
      ])
    ])
  ]))
}